( function() {
	document.addEventListener( 'DOMContentLoaded', function() {
		var filtersEle = document.querySelector( '.facility-filters' );
		if( !filtersEle ) { return; }

		var filterGroupsEles = filtersEle.querySelectorAll( '.facility-filters__single' );
		var contentBlockEle = filtersEle.closest( '.content-block__tabs' );
		
		// Toggle display of filters (small breakpoints)
		filtersEle.querySelectorAll( '.facility-filters__close, .facility-filters__toggle' ).forEach( function( button ) {
			button.addEventListener( 'click', function( e ) {
				e.preventDefault();

				const TABS_OPEN = 'content-block__tabs--open';
				const FILTER_OPEN = 'facility-filters--open';
				const BODY_CLASS = 'modal-open';
				const body = document.body;
				
				if( filtersEle.classList.contains( FILTER_OPEN ) ) {
					filtersEle.classList.remove( FILTER_OPEN );
					body.classList.remove( BODY_CLASS );
					contentBlockEle.classList.remove( TABS_OPEN );
				} else {
					filtersEle.classList.add( FILTER_OPEN );
					body.classList.add( BODY_CLASS );
					contentBlockEle.classList.add( TABS_OPEN );
				}
			} );
		} );

		// Accordion behavior (small breakpoints)
		filtersEle.querySelectorAll( 'a.facility-filters__label' ).forEach( function( accordion ) {
			accordion.addEventListener( 'click', function( e ) {
				e.preventDefault();

				toggleFilterGroup( this.getAttribute( 'href' ) );
			} );
		} );

		// "View All" behavior (larger breakpoints w/ a lot of filters)
		filtersEle.querySelectorAll( '.facility-filters__all' ).forEach( function( filter ) {
			filter.setAttribute( 'originalText', filter.textContent );

			filter.addEventListener( 'click', function( e ) {
				e.preventDefault();
	
				toggleFilterGroup( this.getAttribute( 'href' ) );
	
				// Toggle text
				var originalText = this.getAttribute( 'originalText' );
				if( this.textContent === originalText ) {
					this.textContent = this.dataset.filtersLess;
				} else {
					this.textContent = originalText;
				}
			} );
		} );

		function toggleFilterGroup( idSelector ) {
			filterGroupsEles.forEach( function( id ) {
				if( id.matches( idSelector ) ) {
					id.classList.toggle( 'facility-filters__single--active' );
				}
			} );
		}
	} );
} )();